// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__24mzj","title":"FrontImage_title__d1hfR"};